import { render, staticRenderFns } from "./LandPageArabic.vue?vue&type=template&id=4885b8f2&scoped=true"
import script from "./LandPageArabic.vue?vue&type=script&lang=js"
export * from "./LandPageArabic.vue?vue&type=script&lang=js"
import style0 from "./LandPageArabic.vue?vue&type=style&index=0&id=4885b8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885b8f2",
  null
  
)

export default component.exports